
import CalendarHeader from './CalendarHeader.vue'
import GbAppButton from '../../../../components/AppButton/AppButton.vue'
import isMobile from 'ismobilejs'

export default {
  name: 'CalendarTemplate',
  components: { GbAppButton, CalendarHeader },
  props: {
    isInDashboard: {
      type: Boolean,
      default: false
    },

    daysNames: {
      type: Array,
      required: true
    },

    calendarData: {
      type: Array,
      required: true
    },

    activeEventsLoading: {
      type: Number,
      required: true
    },

    selectDay: {
      type: Function,
      required: true
    },

    currentDate: {
      type: Object,
      required: true
    },

    setCurrentDate: {
      type: Function,
      required: true
    },

    selectToday: {
      type: Function,
      default: () => {}
    },

    cellSize: {
      type: String,
      default: 'small',
      validator: value => ['small', 'wide'].includes(value)
    }
  },

  computed: {
    buttonSize() {
      return isMobile()?.phone ? 44 : 32
    }
  }
}
